import { useTranslation } from 'react-i18next';
import { TextAndImageSelectionField } from '@app/form';
import { SelectionRow } from './SelectionRow';

interface Props {
  isStudy: boolean;
  onIsStudyChange: (isStudy: boolean) => void;
}

export const QuoteSubjectSection = ({ isStudy, onIsStudyChange }: Props) => {
  const { t } = useTranslation();

  return (
    <SelectionRow>
      <TextAndImageSelectionField
        title={t('quote.create.subjectSimple')}
        description={t('quote.create.subjectSimpleHint')}
        name="quoteSubject"
        value="simple"
        isCompact
        checked={!isStudy}
        onChange={() => onIsStudyChange(false)}
        trackingName="Quote subject"
      />
      <TextAndImageSelectionField
        title={t('quote.create.subjectStudy')}
        description={t('quote.create.subjectStudyHint')}
        name="quoteSubject"
        value="study"
        isCompact
        checked={isStudy}
        onChange={() => onIsStudyChange(true)}
        trackingName="Quote subject"
      />
    </SelectionRow>
  );
};
